import { FieldValues, Path } from "react-hook-form";

import { NativeSelectInput } from "#shared/view/designSystem/NativeSelectInput";

import {
  BaseSelectInputController,
  BaseSelectInputControllerProps,
} from "./BaseSelectInputController";

export const NativeSelectInputController = <
  T extends FieldValues,
  IP extends Record<string, unknown> = Record<string, unknown>,
>(
  props: Omit<BaseSelectInputControllerProps<T, IP>, "InputComponent"> & {
    name: Path<T>;
    data: { value: string; label: string }[];
  },
) => {
  return (
    <BaseSelectInputController<T, IP>
      {...(props as BaseSelectInputControllerProps<T, IP>)}
      InputComponent={NativeSelectInput}
      extractValue={(payload) => {
        const maybeEvent = payload as { target?: { value?: string } } | undefined;
        return maybeEvent?.target?.value ?? null;
      }}
    />
  );
};
